module.exports = "https://cdn.hellotech.com/client-assets/routers_desktop_b2c126769b8d149063117bc8d1768e28.png";